export default "__VITE_ASSET__2520e80c__"